import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import '../../hooks/use-safe-layout-effects.esm.js';
import '../../hooks/use-callback-ref.esm.js';
import '../../hooks/use-clickable.esm.js';
import '../../hooks/use-clipboard.esm.js';
import '../../hooks/use-combobox-dropdown-style.esm.js';
import '../../hooks/use-combobox-style.esm.js';
import '../../hooks/use-controllable.esm.js';
import '../../hooks/use-local-storage.esm.js';
import '../../hooks/use-media.esm.js';
import '../../hooks/use-prefers-dark-mode.esm.js';
import '../../hooks/use-dark-mode.esm.js';
import '../../hooks/use-force-update.esm.js';
import '../../hooks/use-descendant.esm.js';
import { useId } from '@reach/auto-id';
import '../../hooks/use-id.esm.js';
import '../../hooks/use-previous.esm.js';
import '../../hooks/use-disclosure.esm.js';
import '../../hooks/use-dropdown-style.esm.js';
import '../../hooks/use-latest-ref.esm.js';
import '../../hooks/use-event-listener.esm.js';
import '../../hooks/use-event-listener-v2.esm.js';
import '../../hooks/use-update-effect.esm.js';
import '../../hooks/use-focus-on-hide.esm.js';
import '../../hooks/use-pointer-event.esm.js';
import '../../hooks/use-focus-on-pointerdown.esm.js';
import '../../hooks/use-focus-on-show.esm.js';
import '../../hooks/use-fork-ref.esm.js';
import '../../hooks/use-hints.esm.js';
import { useInputStyle } from '../../hooks/use-input-style.esm.js';
import '../../hooks/use-key-press.esm.js';
import '../../hooks/use-lock-body-scroll.esm.js';
import '../../hooks/use-platform.esm.js';
import '../../hooks/use-shortcut.esm.js';
import Label from '../Label/index.esm.js';

var Checkbox = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var _props$id = props.id,
      id = _props$id === void 0 ? "checkbox-" + useId() : _props$id,
      name = props.name,
      value = props.value,
      defaultChecked = props.defaultChecked,
      checked = props.checked,
      indeterminate = props.indeterminate,
      disabled = props.disabled,
      invalid = props.invalid,
      readOnly = props.readOnly,
      onChange = props.onChange,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      ariaLabel = props['aria-label'],
      ariaLabelledBy = props['aria-labelledby'],
      children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["id", "name", "value", "defaultChecked", "checked", "indeterminate", "disabled", "invalid", "readOnly", "onChange", "onBlur", "onFocus", "aria-label", "aria-labelledby", "children"]);

  var styleProps = useInputStyle(_extends({
    block: true,
    type: 'checkbox',
    indeterminate: indeterminate
  }, props));
  var comp = React__default.createElement(Box, _extends({
    position: "relative",
    display: "inline-flex",
    alignItems: "items-center"
  }, !children ? rest : {}), "\u200B", indeterminate && React__default.createElement(Box, {
    position: "absolute",
    inset: "inset-0",
    display: "flex",
    alignItems: "items-center",
    justifyContent: "justify-center"
  }, React__default.createElement(Box, {
    margin: "m-auto",
    width: "w-1/2",
    height: "h-0.5",
    backgroundColor: "bg-white",
    borderRadius: "rounded-sm"
  })), React__default.createElement(Box, _extends({
    as: "input",
    ref: ref,
    type: "checkbox",
    id: id,
    name: name,
    value: value,
    defaultChecked: defaultChecked,
    checked: checked,
    disabled: disabled,
    readOnly: readOnly,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    "aria-invalid": invalid,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    dangerouslySetClassName: "form-checkbox"
  }, styleProps)));

  if (!children) {
    return comp;
  }

  return React__default.createElement(Box, _extends({
    display: "flex",
    alignItems: "items-center"
  }, rest), comp, React__default.createElement(Label, {
    htmlFor: id,
    margin: "ml-2",
    textColor: invalid ? 'text-red-500' : undefined
  }, children));
});

if (__DEV__) {
  Checkbox.displayName = 'Checkbox';
}

export default Checkbox;
//# sourceMappingURL=index.esm.js.map
